import { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import KeysSelect from '../KeysSelect';
import { handleHttpErrorStatus } from '../../../../../../utils/handleHttpErrorStatus';
import { labelStyles } from '../../../../../../common/styles/formStyles';
import Grid from '@mui/material/Grid';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { validateUserForm } from "../../util/UserForm.validation";
import {hetch} from "../../../../../../utils/fetch.hooked";


function AddAdministratorForm({ triggerRefetch, roles, handleClose }) {
  const [isFetching, setIsFetching] = useState(false);
  const [keyNames, setKeyNames] = useState([]);
  const [formValues, setFormValues] = useState({
    familyName: '',
    firstName: '',
    patronymic: '',
    position: '',
    email: '',
    login: '',
    role: 1,
    expiredKey: false,
    expiredLicense: false,
    enable: true
  });
  const [keysList, setKeysList] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;
    setFormValues({
      ...formValues,
      [name]: value,//.replace(restrictedSymbolsRegexps[name], ''),
    });
  };

  const handleCheckboxChange = (evt) => {
    const { name, checked } = evt.target;
    setFormValues({
      ...formValues,
      [name]: checked,
    });
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setSubmitted(true);

    if(!validateUserForm(formValues, keyNames, setError)) return;

    setIsFetching(true);
    hetch('/api/administrators', {
      headers: {'Content-Type': 'application/json'},
      method: 'POST',
      body: JSON.stringify({
        email: formValues.email,
        first_name: formValues.firstName,
        family_name: formValues.familyName,
        patronymic: formValues.patronymic,
        position: formValues.position,
        expired_key: formValues.expiredKey,
        expired_license: formValues.expiredLicense,
        key_names: keyNames,
        enable: formValues.enable,
        role: formValues.role,
        login: formValues.login,
      }),
    })
        .then(handleHttpErrorStatus)
        .then(res => res.json())
        .then(() => {
          handleClose();
          triggerRefetch();
        })
        .catch(err => err.json())
        .then(res => {
          if (res) {
            setError(res.message);
          }
        })
        .finally(() => {
          setIsFetching(false);
        });
  };

  useEffect(() => {
    const fetchData = () => {
      hetch('/api/key_names')
        .then(res => res.json())
        .then(res => {
          setKeysList(res?.content ?? []);
        });
    }

    fetchData();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {error ? (
          <Grid item xs={12}>
            <Alert severity="error">{error}</Alert>
          </Grid>
        ) : null}
        <Grid item xs={6}>
          <InputLabel htmlFor='familyName' sx={labelStyles} required={true}>
            Фамилия
          </InputLabel>
          <TextField
            id='familyName'
            name='familyName'
            placeholder='Фамилия пользователя'
            size="small"
            fullWidth
            error={submitted && !formValues.familyName}
            disabled={isFetching}
            value={formValues.familyName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel htmlFor='firstName' sx={labelStyles} required={true}>
            Имя
          </InputLabel>
          <TextField
            id='firstName'
            name='firstName'
            placeholder='Имя пользователя'
            size="small"
            fullWidth
            error={submitted && !formValues.firstName}
            disabled={isFetching}
            value={formValues.firstName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel htmlFor='patronymic' sx={labelStyles}>
            Отчество
          </InputLabel>
          <TextField
            id='patronymic'
            name='patronymic'
            placeholder='Отчество пользователя'
            size="small"
            fullWidth
            disabled={isFetching}
            value={formValues.patronymic}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel htmlFor='position' sx={labelStyles}>
            Должность
          </InputLabel>
          <TextField
            id='position'
            name='position'
            placeholder='Должность пользователя'
            size="small"
            fullWidth
            disabled={isFetching}
            value={formValues.position}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel htmlFor='login' sx={labelStyles} required={true}>
            Логин
          </InputLabel>
          <TextField
              id='login'
              name='login'
              placeholder='Логин пользователя'
              size="small"
              fullWidth
              error={submitted && !formValues.login}
              disabled={isFetching}
              value={formValues.login}
              onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel htmlFor='role' sx={labelStyles} required={true}>
            Роль
          </InputLabel>
          <Select
              id='role'
              name='role'
              size="small"
              fullWidth
              error={submitted && !formValues.role}
              disabled={isFetching}
              value={formValues.role}
              onChange={handleInputChange}
          >
            {roles.map((role) => (<MenuItem value={role.id.toString()}>{role.name}</MenuItem>))}
          </Select>
        </Grid>
        <Grid item xs={12}>
          <InputLabel htmlFor='email' sx={labelStyles} required={true}>
            Адрес электронной почты для уведомлений
          </InputLabel>
          <TextField
            id='email'
            name='email'
            type='email'
            placeholder='Email'
            size="small"
            fullWidth
            error={submitted && !formValues.email}
            disabled={isFetching}
            value={formValues.email}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                disabled={isFetching}
                checked={formValues.expiredLicense}
                onChange={handleCheckboxChange}
                name='expiredLicense'
              />
            }
            label='Уведомлять об истечении срока действия лицензии КриптоПро'
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                disabled={isFetching}
                checked={formValues.expiredKey}
                onChange={handleCheckboxChange}
                name='expiredKey'
              />
            }
            label='Уведомлять об истечении сроков действия ключей'
          />
        </Grid>
        {formValues.expiredKey ? (
          <Grid item xs={8}>
            <KeysSelect keysList={keysList} setKeyNames={setKeyNames} formIsFetching={isFetching}/>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <FormControlLabel
              control={
                <Checkbox
                    disabled={isFetching}
                    checked={formValues.enable}
                    onChange={handleCheckboxChange}
                    name='enable'
                />
              }
              label='Активен'
          />
        </Grid>
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Button
            title="Сохранить"
            variant='contained' type='submit'
            disabled={isFetching}
          >
            Сохранить
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default AddAdministratorForm;
